const PRODUCTION_SHELL_ORIGIN = "https://red.sjesdemos.com";
const LOCAL_SHELL_ORIGIN = "http://localhost:5175";

const AUTH_QUERY_PARAMS = [
  "access_token",
  "client_info",
  "code",
  "correlation_id",
  "error",
  "error_description",
  "id_token",
  "mlink",
  "qlink",
  "refresh_token",
  "session_state",
  "state",
  "token",
] as const;

const COMPONENT_PREFIXES = [
  ["rm-", "ErasRoad"],
  ["tl-", "TimelinePanel"],
  ["graph-", "GraphPanel"],
  ["lens-", "LensGrids"],
  ["ask-", "ChatPanel"],
  ["journey-", "JourneyPanel"],
  ["jfb-", "Feedback"],
  ["fb-", "Feedback"],
  ["carousel", "Carousel"],
  ["topbar", "Topbar"],
  ["nav", "Topbar"],
  ["footer", "Footer"],
  ["hero", "Hero"],
  ["cfg-", "ConfigManagement"],
  ["crumbs", "Breadcrumb"],
] as const;

export function redlinerAllowedParents(dev = import.meta.env.DEV): string[] {
  return dev
    ? [PRODUCTION_SHELL_ORIGIN, LOCAL_SHELL_ORIGIN]
    : [PRODUCTION_SHELL_ORIGIN];
}

export function initRedliner(
  sdk: Window["RedLinerSDK"],
  appVersion: string,
  dev = import.meta.env.DEV,
): void {
  if (!sdk) return;
  sdk.initRedSdk({
    app: { name: "Interactive Résumé", version: appVersion },
    allowedParents: redlinerAllowedParents(dev),
    componentAttr: "data-c",
    componentPrefixes: COMPONENT_PREFIXES,
    stripParams: AUTH_QUERY_PARAMS,
    ignoreSelectors: [".bugpick-bar", ".bugmode-tray", ".bugmode-badge"],
  });
}
